import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Stage3.css";

import imgA from "./images/A.png";
import imgB from "./images/B.png";
import imgC from "./images/C.png";

import Swal from "sweetalert2";
import { fetchReport, updateReport } from "../../scoreservice";
// import { useStageTimer } from "../../hooks/useStageTimer";

const STAGE = 3;

const timeToSeconds = (timeStr = "00:00") => {
  const [m = 0, s = 0] = timeStr.split(":").map(Number);
  return m * 60 + s;
};

const Stage3 = ({ updateHeader }) => {
  useEffect(() => {
    updateHeader({ backButtonRedirect: "/stage3" });


  }, []); // run once on mount
  const navigate = useNavigate();

  const [points, setPoints] = useState(0);
  const [totalScore, setTotalScore] = useState(0);
  const [SESSION_KEY, setSessionKey] = useState(null);
  const [seconds, setSeconds] = useState(0);
  const [minutes, setMinutes] = useState(0);

  const [correctSelected, setCorrectSelected] = useState(false);
  const [wrongSelected, setWrongSelected] = useState(null);
  const [showPopup, setShowPopup] = useState(false);

  const [initialTime, setInitialTime] = useState(null);
  const [ready, setReady] = useState(false);

  // const userData = JSON.parse(sessionStorage.getItem("userData") || "{}");
  const [userData, setUserData] = useState({});

  useEffect(() => {
    const storedUserData = sessionStorage.getItem("userData");
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);


  // const { seconds, stopTimer } = useStageTimer(
  //   STAGE,
  //   ready ? initialTime : null
  // );

  // const formatTime = (seconds) => {
  //   const mins = String(Math.floor(seconds / 60)).padStart(2, "0");
  //   const secs = String(seconds % 60).padStart(2, "0");
  //   return `${mins}:${secs}`;
  // };

  const images = [
    { id: "image1", src: imgA, label: "A" },
    { id: "image2", src: imgB, label: "B" },
    { id: "image3", src: imgC, label: "C" }, // ✅ correct
  ];

  useEffect(() => {
    const checkStageCompletion = async () => {
      try {
        const res = await fetchReport({
          userId: userData.userId,
          sessionId: userData.sessionId,
          organizationId: userData.organizationId,
          stage: STAGE,

        });

        if (userData?.sessionId && userData?.userId) {
          const key = `stage_timer_${userData.sessionId}_${userData.userId}`;
          setSessionKey(key);

          if (!sessionStorage.getItem(key)) {
            sessionStorage.setItem(
              key,
              JSON.stringify({
                userId: userData.userId,
                sessionId: userData.sessionId,
                startTime: Date.now(),
              })
            );
          }
        }

        console.log("data3", res);
        if (Number(res?.points) !== 0) {
          navigate("/stage4", { replace: true });
        }


      } catch (err) {
        console.error("Stage check failed", err);
      }
    };

    if (userData?.sessionId) {
      checkStageCompletion();
    }
  }, [userData]);


  useEffect(() => {
    const loadStageData = async () => {
      if (!userData?.userId) return;

      try {
        const res = await fetchReport({
          userId: userData.userId,
          sessionId: userData.sessionId,
          organizationId: userData.organizationId,
          stage: STAGE,
        });

        if (res.status === "success") {
          setPoints(res.points || 0);
          setTotalScore(res.total_score || 0);
          setInitialTime(res.time || "00:00");

          if ((res.points || 0) > 0) {
            setCorrectSelected(true);
          }
        } else {
          setInitialTime("00:00");
        }
      } catch (err) {
        console.error("Fetch stage3 failed", err);
        setInitialTime("00:00");
      } finally {
        setReady(true);
      }
    };

    loadStageData();
  }, [userData]);

  /* 🔹 Image click logic */
  const handleImageClick = (id) => {
    if (correctSelected) return;

    if (id === "image3") {
      setPoints(1);
      setCorrectSelected(true);
      setWrongSelected(null);
    } else {
      setWrongSelected(id);
    }
  };




  // useEffect(() => {
  //   const sessionData = sessionStorage.getItem(SESSION_KEY);

  //   if (!sessionData) return;

  //   const { startTime } = JSON.parse(sessionData);

  //   const interval = setInterval(() => {
  //     const elapsedMs = Date.now() - startTime;
  //     const totalSeconds = Math.floor(elapsedMs / 1000);

  //     const mins = Math.floor(totalSeconds / 60);
  //     const secs = totalSeconds % 60;

  //     setMinutes(mins);
  //     setSeconds(secs);
  //   }, 1000);

  //   return () => clearInterval(interval);
  // }, [SESSION_KEY])


  useEffect(() => {
    if (!initialTime) return;

    const baseSeconds = timeToSeconds(initialTime);
    const startTime = Date.now();

    const interval = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - startTime) / 1000);
      const totalSeconds = baseSeconds + elapsedSeconds;

      setMinutes(Math.floor(totalSeconds / 60));
      setSeconds(totalSeconds % 60);
    }, 1000);

    return () => clearInterval(interval);
  }, [initialTime]);




  const formattedTime = `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;

  /* 🔹 Submit */
  const handleSubmit = async () => {
    // stopTimer();
    console.log("total score222---", totalScore);

    try {
      await updateReport({
        sessionId: userData.sessionId,
        userId: userData.userId,
        organizationId: userData.organizationId,
        reportId: userData.reportId,
        stage: STAGE,
        score: points + totalScore,
        time: formattedTime,
        roles: userData.roles,
        token: userData.token || ""
      });

      Swal.fire({
        imageUrl: "/img/success.gif",
        showConfirmButton: false,
        timer: 3000,
        background: "transparent",
      });

      setTimeout(() => {
        navigate("/stage4");
      }, 3000);
    } catch (err) {
      console.error("Stage3 submit error", err);
    }
  };

  /* 🔹 UI */
  return (
    <div className="stage3-page-bg">
      <div className="stage3-bg">

        {/* HEADER */}
        {/* <div className="top-bar-3">
          <div className="timer-back-s3">
            Time: {formattedTime}
          </div>
          <h4 className="gameHead-s3">
            Forensic Check: Identify the prime suspect by matching their fingerprints with those found at the crime scene.
          </h4>
          <div className="score-s3">
            Points: {totalScore}
          </div>

        </div> */}

        <div className="row header33">
          <div className="timer-33">
            Time: {formattedTime}
          </div>
          <div className="title-wrap-33">  <h4 className="gameHead-33">
            Forensic Check: Identify the prime suspect by matching their fingerprints with those found at the crime scene.
          </h4>
          </div>

          <div className="score-33">Points: {totalScore}</div>
        </div>

       
        {/* IMAGES */}
        <div className="image-row">
          {images.map(({ id, src, label }) => (
            <div
              key={id}
              className={`image-wrapper
                ${id === "image3" && correctSelected ? "correct" : ""}
                ${id === wrongSelected ? "wrong" : ""}
              `}
              onClick={() => handleImageClick(id)}
            >
              <img
                src={src}
                alt={`Fingerprint ${label}`}
                className="clickable-image"
              />
            </div>
          ))}
        </div>

        {/* SUBMIT */}
        <div className="submit-wrapper">
          <button
            className="submit-button"
            disabled={!correctSelected}
            onClick={handleSubmit}
          />
        </div>
      </div>
    </div>
  );
};

export default Stage3;
